import DetailBDS3 from "./DetailBDS3";
import { Tabs } from 'components/common';
import DetailBDS2 from "./DetailBDS2";
import DetailBDS1 from "./DetailBDS1";
import React from "react";
import PropTypes from 'prop-types';
const DetailBDS = ({project, building, adaptation, area, areaIndex}) => {

  return (
    <>
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-2 tw-text-sm">
        <div className="tw-text-primary-600 tw-font-semibold">Area {area?.id}</div>
      </div>

      <Tabs
        variant="underline"
        lazyMount
        navClassName="tw-bg-white tw-px-2 tw-pt-1 tw-border tw-border-solid tw-border-slate-200 tw-rounded-t"
        contentClassName="tw-bg-slate-50 tw-text-sm tw-border tw-border-t-0 tw-border-solid tw-border-slate-200 tw-rounded-b"
        tabs={[
          {
            label: 'BDS1',
            content: (
              <DetailBDS1
                project={project}
                building={building}
                adaptation={adaptation}
                area={area}
                areaIndex={areaIndex}
              />
            )
          },
          {
            label: 'BDS2',
            content: (
              <DetailBDS2
                project={project}
                building={building}
                adaptation={adaptation}
                area={area}
                areaIndex={areaIndex}
              />
            )
          },
          {
            label: 'BDS3',
            content: (
              <DetailBDS3
                project={project}
                building={building}
                adaptation={adaptation}
                area={area}
                areaIndex={areaIndex}
              />
            )
          }
        ]}
      />
    </>
  )
};

DetailBDS.propTypes = {
  project: PropTypes.object.isRequired,
  building: PropTypes.object.isRequired,
  adaptation: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  areaIndex: PropTypes.number
}

export default DetailBDS;
